export default "__VITE_ASSET__b6a18b46__"